export const ERROR_TYPES = {
  GROUP_NOT_FOUND: 'GROUP_NOT_FOUND',
};
